import { render, staticRenderFns } from "./QuizRenderer.vue?vue&type=template&id=2c22e530&scoped=true&"
import script from "./QuizRenderer.vue?vue&type=script&lang=js&"
export * from "./QuizRenderer.vue?vue&type=script&lang=js&"
import style0 from "./QuizRenderer.vue?vue&type=style&index=0&id=2c22e530&prod&scoped=true&lang=scss&"
import style1 from "./QuizRenderer.vue?vue&type=style&index=1&id=2c22e530&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22e530",
  null
  
)

export default component.exports